import useAxios from 'axios-hooks';

export default function useGetContributorsByName() {
  const common = query => ({ params: { search_term: query } });
  const [state, q] = useAxios({
    url: '/api/v1/contributors/search',
    cache: { ignoreCache: true },
    method: 'GET',
  }, { manual: true });
  const executeQuery = query => q(common(query));
  return [state, executeQuery];
}
